export default {
  callback: {
    type: Function,
    default: null,
  },
}



// WEBPACK FOOTER //
// ./src/js/util/props/callback.js